// extracted by mini-css-extract-plugin
export default {"search-input":"SearchInput_search-input__ZHEhU","icon-wrapper":"SearchInput_icon-wrapper__h3uAT","error":"SearchInput_error__UWT7o","clear-button":"SearchInput_clear-button__GFVcT"};